<img
  [src]="getNotificationIcon(severity)"
  [alt]="severity + ' icon'"
  [class]="getSizeClasses() + ' flex-shrink-0'"
/> 